import { Debounce, deepCopy, getShortId } from '@nyanyajs/utils'
import { notesSlice, state } from '.'
import store, { configSlice } from '..'
import { protoRoot } from '../../protos'
import { CategoryItem, NoteItem, PageItem } from './typings'
import { storage } from '../storage'
import electronApi from '../../modules/electron/api'
import api, { httpApi } from '../../modules/http/api'
import { toHaveStyle } from '@testing-library/jest-dom/matchers'
import { diffJson } from 'diff'
import { alert, snackbar } from '@saki-ui/core'
import i18n from '../../modules/i18n/i18n'

const syncLoadingDebounce = new Debounce()

export interface ContentResult {
  note?: protoRoot.note.INoteItem
  category?: protoRoot.note.ICategoryItem
  page?: protoRoot.note.IPageItem
  todoList?: protoRoot.note.ITodoListPageItem[]
}

export const getContent = ({
  categoryId,
  noteId,
  pageId,
}: {
  noteId: string
  categoryId: string
  pageId: string
}): ContentResult => {
  const { notes } = store.getState()

  const result: ContentResult = {}

  noteId &&
    notes.list.some((v) => {
      if (v.id === noteId) {
        result.note = v
        categoryId &&
          v.categories?.some((sv) => {
            if (sv.id === categoryId) {
              result.category = sv

              pageId &&
                sv.data?.some((ssv) => {
                  if (ssv.id === pageId) {
                    result.page = ssv
                    if (ssv.type === 'TodoList') {
                      // let todoList: protoRoot.note.ITodoListPageItem[]
                      //   = (JSON.parse(ssv?.content || '[]') || [])
                      // console.log('todoList1', ssv.todoList, ssv, !ssv.todoList?.length && ssv?.content)
                      if (!ssv.todoList?.length && ssv?.content) {
                        ssv.todoList = (JSON.parse(ssv?.content || '[]') ||
                          []) as protoRoot.note.ITodoListPageItem[]
                      }
                      result.todoList =
                        ssv.todoList
                          ?.map((v) => {
                            return {
                              ...v,
                              parentId: v.parentId || '',
                            }
                          })
                          .filter((v) => (v.status || 0) >= 0) || []
                    }

                    return true
                  }
                })
              return true
            }
          })

        return true
      }
    })

  return result
}

export const getId = (): string => {
  const id = getShortId(9)
  const { notes } = store.getState()

  let exist = false

  notes.list.some((v) => {
    if (v.id === id) {
      exist = true
      return true
    }
    v.categories?.some((sv) => {
      if (sv.id === id) {
        exist = true
        return true
      }

      sv.data?.some((ssv) => {
        if (ssv.id === id) {
          exist = true
          return true
        }
        ssv.todoList?.some((sssv) => {
          if (sssv.id === id) {
            exist = true
            return true
          }
        })
      })
    })
  })

  if (exist) {
    return getId()
  }
  return id
}

export const saveNote = async (payload: {
  id: string
  v: (typeof state.list)[0]
  requestParams?: protoRoot.sync.SyncToServer.IRequest
}) => {
  // console.log(payload)
  // return

  if (!payload?.id) return
  payload = deepCopy(payload)
  let note = payload.v
  console.log(deepCopy(note))

  // const note = JSON.parse(JSON.stringify(payload.v))

  // saveNoteDebounce.increase(() => {
  setTimeout(() => {
    try {
      console.log('-------saveNote------- 版本', payload)

      const { user, config } = store.getState()

      config.sync &&
        store.dispatch(
          configSlice.actions.setStatus({
            type: 'syncStatus',
            v: true,
          })
        )
      // console.log('payload.id')
      // console.log(payload.id, note)
      storage.notes.set(payload.id, note).then(async () => {
        // console.log('payload.id')
        // console.log(payload.id)
        console.log('config.platform', config.platform)
        switch (config.platform) {
          case 'Electron':
            electronApi.api.updateData()
            break

          default:
            break
        }

        if (payload.requestParams) {
          store.dispatch(
            notesSlice.actions.setNoteLastUpdateTime({
              id: payload.id,
              lastUpdateTime: Math.floor(new Date().getTime() / 1000),
              syncTime: Math.floor(new Date().getTime() / 1000),
            })
          )
        }
        console.log('  config.sync 版本', config.sync, payload)
        if (config.sync) {
          // && note.isSync
          if (isNoteSync(note, 5)) {
            if (user.isLogin) {
              console.log('同步远端')
              console.log(payload.requestParams)
              if (payload.requestParams) {
                const res = await api.v1.syncToServer(payload.requestParams)

                console.log(
                  'res 版本 ssv.todoList mergeObj',
                  res,
                  payload.requestParams,
                  res.code
                )
                if (res.code === 10021) {
                  console.log('添加', payload.id, note)
                  saveNote({
                    id: payload.id,
                    v: note,
                    requestParams: {
                      type: 'Note',
                      methods: 'Add',
                      options: {
                        noteId: payload.id,
                      },
                      data: {
                        note: { ...note },
                      },
                    },
                  })
                  return
                }
                if (res.code === 200) {
                  // const lastUpdateTime = new Date().getTime()

                  if (res.data?.lastUpdateTime) {
                    let t =
                      Number(res.data.lastUpdateTime) || note.lastUpdateTime
                    store.dispatch(
                      notesSlice.actions.setNoteLastUpdateTime({
                        id: payload.id,
                        lastUpdateTime: Number(t),
                        syncTime: Number(t),
                      })
                    )
                  }

                  // note.lastUpdateTime = lastUpdateTime
                  // console.log(res.data.urls)
                  // console.log(
                  // 	(res.data.urls?.domainUrl || '') +
                  // 		(res.data.urls?.encryptionUrl || '')
                  // )
                  // console.log(
                  // 	(res.data.urls?.domainUrl || '') + (res.data.urls?.url || '')
                  // )
                }
              }

              syncLoadingDebounce.increase(() => {
                store.dispatch(
                  configSlice.actions.setStatus({
                    type: 'syncStatus',
                    v: false,
                  })
                )
              }, 500)
              return
            }
          } else {
            if (note.authorId !== user.userInfo.uid) {
              console.log('这是其他人的日记')
            }
            console.log('禁用同步')
          }
          syncLoadingDebounce.increase(() => {
            store.dispatch(
              configSlice.actions.setStatus({
                type: 'syncStatus',
                v: false,
              })
            )
          }, 500)
        }
        // console.log('  config.sync 版本', config.sync)
      })
    } catch (error) {
      console.error(error)
      console.trace(error)
    }
  }, 50)
  // }, 700)
}

export const pushNoteMergeOrReplaceAlert = async (
  note: protoRoot.note.INoteItem
) => {
  if (!note?.id) return
  const t = i18n.t

  alert({
    title: t('pushToCloud', {
      ns: 'indexPage',
    }),
    content: t('pushToCloudMergeOrReplaceContent', {
      ns: 'indexPage',
    }),
    cancelText: t('replace', {
      ns: 'indexPage',
    }),
    confirmText: t('merge', {
      ns: 'indexPage',
    }),
    onCancel() {
      saveNote({
        id: note.id || '',
        v: note,
        requestParams: {
          type: 'Note',
          methods: 'Update',
          options: {
            noteId: note.id,
          },
          data: {
            note,
          },
        },
      })
    },
    async onConfirm() {
      await getNoteByCloud(note.id || '', 'Merge')
    },
  }).open()
}

export const getNoteMergeOrReplaceAlert = async (id: string) => {
  const t = i18n.t

  alert({
    title: t('downloadNote', {
      ns: 'indexPage',
    }),
    content: t('getNoteMergeOrReplaceContent', {
      ns: 'indexPage',
    }),
    cancelText: t('replace', {
      ns: 'indexPage',
    }),
    confirmText: t('merge', {
      ns: 'indexPage',
    }),
    onCancel() {
      getNoteByCloud(id, 'Replace')
    },
    onConfirm() {
      getNoteByCloud(id, 'Merge')
    },
  }).open()
}

export const getNoteByCloud = async (
  id: string,
  type: 'Merge' | 'Replace' = 'Merge'
) => {
  const { notes, user } = store.getState()
  const res = await api.v1.getNote({
    id: id,
    type:
      notes.list.filter((v) => v.id === id)?.[0]?.authorId !== user.userInfo.uid
        ? 'Collaborators'
        : '',
  })

  console.log('getNoteByCloud', res, id, res.data?.note?.name)
  if (res.code === 200 && res.data?.note) {
    store.dispatch(
      notesSlice.actions.mergeNoteByCloud({
        id: id,
        v: res.data.note,
        type,
      })
    )

    // const pRes = await httpApi.v1.GetNotePermissions(
    //   {
    //     noteId: id,
    //   }
    // )
    // console.log('getNoteByCloud GetNotePermissions', pRes)
    // if (res.code === 200) {

    // }
  } else {
    snackbar({
      message: i18n.t('noteDoesNotExist', {
        ns: 'prompt',
        id,
      }),
      vertical: 'top',
      horizontal: 'center',
      autoHideDuration: 2000,
      closeIcon: true,
    }).open()
  }
}

export const formatNote = (note: protoRoot.note.INoteItem) => {
  // console.log(' note?.status ', deepCopy(note), note?.status)
  note.status = typeof note?.status === 'number' ? note.status || 1 : 1
  note.deleteTime = note?.deleteTime || -1
  note.deleteUserId = note?.deleteUserId || []
  if (note.status >= 0) {
    note.deleteTime = -1
    note.deleteUserId = []
  }

  note.categories =
    note.categories?.map((cate) => {
      cate.status = typeof cate?.status === 'number' ? cate.status || 1 : 1
      cate.deleteTime = cate?.deleteTime || -1
      cate.deleteUserId = cate?.deleteUserId || []
      if (cate.status >= 0) {
        cate.deleteTime = -1
        cate.deleteUserId = []
      }

      cate.data =
        cate.data?.map((page) => {
          page.status = typeof page?.status === 'number' ? page.status || 1 : 1
          page.deleteTime = page?.deleteTime || -1
          page.deleteUserId = page?.deleteUserId || []
          if (page.status >= 0) {
            page.deleteTime = -1
            page.deleteUserId = []
          }

          page.encryption =
            page.type === 'Encryption' ? 2 : page.encryption || -1

          if (page.type === 'TodoList') {
            if (!page?.todoList) {
              page.todoList = []
            }
            // let todoList: protoRoot.note.ITodoListPageItem[]
            //   = (JSON.parse(page?.content || '[]') || [])
            let todoList = page.todoList
            if (!todoList.length && page?.content) {
              todoList = (JSON.parse(page?.content || '[]') ||
                []) as protoRoot.note.ITodoListPageItem[]
            }

            const todoListTimestamp = todoList.map((v) => v.createTime || 0)

            todoListTimestamp.sort((a, b) => a - b)

            const todoListDisplayId = Object.fromEntries(
              todoListTimestamp.map((t, i) => {
                return [t, 'SA-' + (i + 1)]
              })
            )

            page.todoList = todoList.map((todo) => {
              todo.status = typeof todo?.status === 'number' ? todo.status : 0
              todo.displayId = todoListDisplayId[Number(todo.createTime)]
              todo.deleteTime = todo?.deleteTime || -1
              todo.disable = todo.disable || -1
              todo.deleteUserId = todo?.deleteUserId || []
              if (todo.status >= 0) {
                todo.deleteTime = -1
                todo.deleteUserId = []
              }

              return {
                ...todo,
                parentId: todo.parentId || '',
              }
            })
          }

          return { ...page }
        }) || []

      cate.data.sort((a, b) => (b.sort || 0) - (a.sort || 0))

      return { ...cate }
    }) || []

  note.categories.sort((a, b) => (b.sort || 0) - (a.sort || 0))

  note = deepCopy(note)

  // console.log('formatNote', note)

  return note
}

export const getSortIndex = <T = any>(arr: T[], oldIndex: number) => {
  let index = -1

  const id = getParameters<string>(
    arr.filter((v: any) => v.status >= 0)?.[oldIndex],
    'id'
  )

  arr.some((v, i) => {
    if ((v as any)?.id === id) {
      index = i
      return true
    }
  })
  return index
}

// 线下版本不管是否大于线上，都要先拉取，再推送
// 如果线下大于线上，就拉取+推送
// 如果线下小于线上，就仅拉取合并
// 本地状态为删除，则比较更新时间来判断是否恢复
// 远端没有，则本地肯定删除
// userId满足后在远端清除

interface DiffResult<T> {
  added: boolean
  removed: boolean
  oldValue: T
  newValue: T
}

const getParameters = <T = any>(val: any, k: string): T => {
  return (val as any)[k]
}

const diffArray = <
  T = {
    [k: string]: any
  },
>(
  oldData: T[],
  newData: T[]
) => {
  const result: {
    [id: string]: DiffResult<T>
  } = {}

  let oldDataObj = Object.fromEntries(
    oldData.map((v) => {
      const id = getParameters<string>(v, 'id')
      return [id, v]
    })
  )
  let newDataObj = Object.fromEntries(
    newData.map((v) => {
      const id = getParameters<string>(v, 'id')
      return [id, v]
    })
  )
  // console.log("mergeNoteByCloud", oldDataObj, newDataObj)

  oldData.forEach((v) => {
    const id = getParameters<string>(v, 'id')

    const nv = newDataObj[id]

    result[id] = {
      added: false,
      removed: !nv,
      oldValue: v,
      newValue: nv,
    }
  })

  newData.forEach((v) => {
    const id = getParameters<string>(v, 'id')

    const nv = oldDataObj[id]

    if (!nv) {
      result[id] = {
        added: !nv,
        removed: false,
        oldValue: nv,
        newValue: v,
      }
    }
  })

  // 1、都有的

  // 2、云端有本地无

  // 3、本地有云端无

  return Object.keys(result).map((k) => {
    return result[k]
  })
}

const mergeObj = <
  T = {
    [k: string]: any
  },
>(
  oldData: T,
  newData: T
): {
  val: T
  old: boolean
  new: boolean
} => {
  if ((newData as any)?.lastUpdateTime >= (oldData as any)?.lastUpdateTime) {
    return {
      val: {
        ...oldData,
        ...newData,
      },
      new: true,
      old: false,
    }
  }
  console.log('mergeObj localUpdate', oldData, newData)
  return {
    val: {
      ...newData,
      ...oldData,
    },
    new: false,
    old: true,
  }
}

export const mergeNote = (
  oldNote: protoRoot.note.INoteItem,
  newNote: protoRoot.note.INoteItem
) => {
  console.log('mergeNoteByCloud', oldNote, newNote)

  let localUpdate = false

  const note = mergeObj(oldNote, newNote)

  if (note.old) {
    localUpdate = true
  }

  // if (newNote.categories?.[1]) {
  //   newNote.categories[1].lastUpdateTime += 19099
  //   newNote.categories[1].name = "newwwwwwwwww"
  //   if (newNote.categories[1].data?.[1]) {
  //     newNote.categories[1].data[1].lastUpdateTime += 19099
  //     newNote.categories[1].data[1].title = "ceeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
  //   }
  // }

  const cateDiff = diffArray(
    oldNote?.categories || [],
    newNote?.categories || []
  )
  note.val.categories = cateDiff
    .filter((v) => !v.removed)
    .map((v) => {
      const cate = mergeObj(v.oldValue, v.newValue)

      if (cate.old) {
        localUpdate = true
      }
      cate.val.data = diffArray(v.oldValue?.data || [], v.newValue?.data || [])
        .filter((v) => !v.removed)
        .map((v) => {
          const page = mergeObj(v.oldValue, v.newValue)

          if (page.old) {
            localUpdate = true
          }
          page.val.todoList = diffArray(
            v.oldValue?.todoList || [],
            v.newValue?.todoList || []
          )
            .filter((v) => !v.removed)
            .map((v) => {
              const todo = mergeObj(v.oldValue, v.newValue)
              if (todo.old) {
                localUpdate = true
              }
              return todo.val
            })
          return page.val
        })

      return cate.val
    })
  console.log(
    'mergeNoteByCloud1',
    cateDiff,
    deepCopy(note),
    note.val.name,
    localUpdate
  )

  console.log('mergeNoteByCloud localUpdate', localUpdate)

  return {
    note: formatNote(note.val),
    localUpdate,
  }
}

export const isNoteSync = (
  note: protoRoot.note.INoteItem,
  permission: 1 | 5 | 100
) => {
  if (!note) return false
  const { notes, user } = store.getState()

  const isSync =
    note.isSync &&
    (note.authorId === user.userInfo.uid ||
      (notes.permissions[note.id || '']?.filter(
        (v) => v.authorId === user.userInfo.uid
      )?.[0]?.permission || 0) >= permission)

  return isSync
}

export const isShowEnbalSyncButton = (
  note: protoRoot.note.INoteItem,
  permission: 1 | 5 | 100
) => {
  if (!note) return false
  const { notes, user, config } = store.getState()

  const isSync =
    note.authorId === user.userInfo.uid ||
    (notes.permissions[note.id || '']?.filter(
      (v) => v.authorId === user.userInfo.uid
    )?.[0]?.permission || 0) >= permission

  return isSync && config.sync
}

export const getNotePermissions = async (noteId: string) => {
  const { notes } = store.getState()
  const npRes = await httpApi.v1.GetNotePermissions({
    noteId: noteId,
  })
  console.log('GetNotePermissions', npRes)
  if (npRes.code === 200 && npRes.data?.list) {
    let obj = {
      ...notes.permissions,
    }
    obj[noteId] = npRes.data?.list

    store.dispatch(notesSlice.actions.setPermissions(obj))
  }
}

export const cleanNote = (list: protoRoot.note.INoteItem[]) => {
  list = list
    .filter((v) => Number(v.status) >= 0)
    .map((v) => {
      const categories = v.categories
        ?.filter((sv) => Number(sv.status) >= 0)
        .map((ssv) => {
          const pages = ssv.data?.filter((sssv) => {
            return Number(sssv.status) >= 0
          })
          return {
            ...ssv,
            data: pages,
          }
        })

      return {
        ...v,
        categories: categories,
      }
    })
  // console.log('cleanNote', list)
  return deepCopy(list)
}
